<template>
    <div id="lv1">
        <!-- Hero Section with Dynamic Background -->
        <div id="hero-section">
            <div id="hero-background" :style="heroBackgroundStyle" class="blurred-dark-background"></div>
            <div id="widget-container">
                <SearchWidget></SearchWidget>
            </div>
        </div>

        <!-- Regions Section -->
        <div id="regionsContainer">
            <RegionCarousel></RegionCarousel>
        </div>

        <!-- Boxes Section -->
        <div class="container" style="margin-top: 20px; margin-bottom: 20px;">
            <div class="row row-eq-height">
                <template v-for="box in boxes" >
                    <div class="col-lg-6 col-md-12 col-xs-12 boxCol" :key="box.title">
                        <IconBox 
                            :title="box.title" 
                            :icon="box.icon"
                            :buttonTitle="box.buttonTitle" 
                            :buttonHref="box.buttonHref"
                        >
                            <h4 v-if="box.content.title">{{ box.content.title }}</h4>
                            <p v-if="box.content.description">{{ box.content.description }}</p>
                        </IconBox>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { viewMixin } from '../mixins/viewMixin';
import IconBox from "@/components/level1/IconBox";
import RegionCarousel from "@/components/level1/RegionCarousel";
import SearchWidget from "@/components/level2/searchWidget/SearchWidget";

export default {
    name: 'LevelOneView',
    mixins: [viewMixin],
    components: {
        SearchWidget,
        IconBox,
        RegionCarousel
    },
    metaInfo() {
        return {
            title: `casafile - Ferienwohnung Tessin, Ferienhaus, Rustico, Lago Maggiore, Locarno, Lugano, Ascona, Gambarogno, Ferien im Ticino mit Hund un Kinder`
        }
    },
    computed: {
        boxes: function() {
            return [
                this.$i18n.t('views.lv1.boxes.presentation'),
                this.$i18n.t('views.lv1.boxes.clients'),
                this.$i18n.t('views.lv1.boxes.estimates'),
                this.$i18n.t('views.lv1.boxes.sale')
            ]
        },
        heroBackgroundStyle() {
            return {
                backgroundImage: `url(${this.images[this.currentImageIndex].url})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                transition: 'background-image 1s ease-in-out'
            };
        }
    },
    data() {
        return {
            images: [
                { url: require('@/assets/images/ticino01.jpg') },
                { url: require('@/assets/images/ticino02.jpg') },
                { url: require('@/assets/images/ticino03.jpg') },
                { url: require('@/assets/images/ticino04.jpg') }
            ],
            currentImageIndex: 0
        }
    },
    mounted() {
        setInterval(() => {
            this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;
        }, 10000);
    }
}
</script>

<style lang="scss" scoped>
/* Hero Section */
#hero-section {
    position: relative;
    min-height: calc(100vh - #{$navbar-height});
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.blurred-dark-background {
    position: relative;
    overflow: hidden;
}

.blurred-dark-background::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: inherit;
    filter: blur(3.2px) brightness(85%);
    z-index: -1;
}

#hero-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
}

#widget-container {
    z-index: 1;
    padding: 50px;
    border-radius: 10px;
 
    width: auto;
}

/* Regions Section */
#regionsContainer {
    background-color: white;
    padding: 48px 0;
}

/* Box Section */
.boxCol {
    margin: 20px 0;
}
</style>
